import {h, Fragment} from "preact"
export default StarRating = ({ rating, reviewCount }) => {
    const fullStars = Math.floor(rating);
    const decimal = rating - fullStars;
    const stars = Array(5).fill(null);
    const ratingId = `rating-${Math.random().toString(36).substr(2, 9)}`;

    const getStarType = (index) => {
        if (index < fullStars) return { filled: true };
        if (index === fullStars && decimal >= 0.3) return { partial: true };
        return { filled: false };
    };

    return (
        <div class="yotpo-reviews-star-ratings-widget yotpo-star-ratings-widget-override-css yotpo-device-desktop yotpo-display-l yotpo-star-ratings-clickable">
            <div class="yotpo-widget-clear">
                <div class="yotpo-bottom-line-scroll-panel" style="display: flex; align-items: center; flex-flow: wrap;">
                    <div class="yotpo-sr-bottom-line-summary" style="display: flex; flex-direction: row; align-items: center; direction: ltr;">
                        <div aria-label={`${rating} out of 5 star rating`} style="display: flex; flex-direction: row; margin-left: 0px; margin-right: 10px; align-items: center;">
                            <span class="sr-only" id={ratingId}>{rating} out of 5 star rating</span>
                            {stars.map((_, index) => (
                                <div aria-labelledby={ratingId} class="star-container yotpo-sr-star-full" style="display: flex; flex-direction: row; margin-right: 3.5px;">
                                    <StarIcon {...getStarType(index)} />
                                </div>
                            ))}
                        </div>
                        <div class="yotpo-sr-bottom-line-left-panel yotpo-sr-bottom-line-score" tabindex="0" role="link" aria-label={`${rating} out of 5 star rating`} style="display: flex; align-self: center; color: rgb(240, 207, 105); font-family: 'Nunito Sans'; font-style: normal; font-weight: 700; font-size: 16px; line-height: 18px; margin-left: 8px; margin-right: 0px; margin-bottom: 1px;">
                            {rating}
                        </div>
                        <div class="yotpo-sr-vertical-border" style="display: flex; place-self: center; height: 11px; border-right: 1px solid black; margin-right: 12px; margin-left: 0px;" />
                        <div class="yotpo-sr-bottom-line-right-panel" style="display: flex;">
                            <div class="yotpo-sr-bottom-line-text yotpo-sr-bottom-line-text--right-panel" style="white-space: nowrap; font-size: 16px; line-height: 18px; text-align: start; font-family: 'Nunito Sans'; font-style: normal; font-weight: 700; color: rgb(44, 44, 44);">
                                {reviewCount} Reviews
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
